module.exports = __webpack_public_path__ + "img/title-icon.d200d8f2.svg";